<template>
  <div v-if="item.tags" class="tagList" :style="{ width: tagsListWidth }">
    <sl-badge v-if="item.productStatus !== 'ACTIVE'" variant="primary" class="badgeSparePart">{{
      $t(`productStatus.${item.productStatus}`)
    }}</sl-badge>
    <template v-else>
      <sl-badge v-if="item.tags.includes('New In')" variant="primary" class="badgeNew"
        >New</sl-badge
      >
      <sl-badge v-if="item.tags.includes('Sustainable')" variant="primary" class="badgeSustainable"
        >Acetate Renew</sl-badge
      >
      <sl-badge v-if="item.tags.includes('Top Pick')" variant="primary" class="badgeTopPick">{{
        $t('product.badges.topPick')
      }}</sl-badge>
      <sl-badge
        v-if="item.productStatus === 'COMING_SOON'"
        variant="primary"
        class="badgeCommingSoon"
        >Coming soon</sl-badge
      >
    </template>
    <sl-badge
      v-if="
        deviceStore.settings.warehouse === stockLocation &&
        handoverPossible &&
        deviceStore.settings.stockLocationId !== deviceStore.settings.serviceHubId
      "
      variant="primary"
      class="badgeHandover"
      >{{ $t('globals.handover') }}</sl-badge
    >
    <sl-badge v-if="assemblyInServicehub" variant="primary" class="">{{
      $t('globals.assemplyInSH')
    }}</sl-badge>
    <sl-badge
      v-if="
        item?.price.default[deviceStore.settings.country]?.compareAt !==
        item?.price.default[deviceStore.settings.country]?.price
      "
      variant="primary"
      class="badgeSale"
      >Sale</sl-badge
    >
  </div>
</template>

<script setup>
import '@shoelace-style/shoelace/dist/components/tag/tag'
import { useDeviceStore } from '@/stores/device'

const deviceStore = useDeviceStore()

defineProps({
  item: {
    type: Object,
    default: () => ({})
  },
  stockLocation: {
    type: String,
    default: ''
  },
  isSparePart: {
    type: Boolean,
    default: false
  },
  handoverPossible: {
    type: Boolean,
    default: true
  },
  assemblyInServicehub: {
    type: Boolean,
    default: false
  },
  tagsListWidth: {
    type: String,
    default: '214px'
  }
})
</script>

<style scoped lang="postcss">
.tagList {
  .configurator__image & {
    width: 100%;
  }

  sl-badge + sl-badge {
    margin-left: 0.5rem;
  }
}
</style>
